import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const DialogBox = styled.div`
  width: 530px;
  max-height: 485px;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  background-color: ${ColorSF2.whisperGray};
  color: ${ColorSF2.black};
  box-shadow: 0 1px 6px ${ColorSF2.transparentShadow};
  @media (max-height: 530px) {
    max-height: 310px;
  }
  @media (max-width: 530px) {
    width: 300px;
  }
`;
export const Contents = styled.div`
  z-index: 1002;
`;
export const SearchBoxWrapper = styled.div`
  margin: 0px 15px 0px 20px;
  position: relative;
  display: flex;
  align-items: center;
`;
export const SearchBoxInputField = styled.input`
  width: 100%;
  height: 32px;
  padding-left: 30px;
  font-size: 14px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const SearchImage = styled.img`
  height: 24px;
  position: absolute;
  left: 4px;
`;
export const CheckboxWrapper = styled.div`
  margin: 16px 15px 15px 20px;
  display: flex;
  align-items: center;
`;
export const Checkbox = styled.div`
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  margin-right: 8px;
  width: 18px;
  height: 18px;
`;

export const GroupsWrapper = styled.div`
  margin-top: 10px;
  overflow-y: auto;
  max-height: 395px;
  @media (max-height: 530px) {
    max-height: 200px;
  }
`;
export const GroupNameWrapper = styled.div`
  height: 48px;
  padding: 0px 15px 0px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-top: 1px solid ${ColorSF2.mediumGray};
  font-weight: bold;
`;
export const ChipWrapper = styled.div`
  margin-right: 8px;
`;
export const GroupName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
`;
